import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function NewAccountDialog(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogContent>
        {TR.cm_go_to_shop_to_redeem_free_period_and_return}
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="success" onClick={props.onOk}>Ok</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default NewAccountDialog;